const baseProfile = {
  layout: 'default',
  homeLabel: 'Inicio',
  allLabel: 'Ver todo',
  showIndex: true,
  maxCategories: 8,
  stripAriaLabel: 'Categorías principales',
  searchPlaceholder: 'Buscar productos...',
};

export const DESIGN_MENU_PROFILES = {
  'bazar-lumina': {
    layout: 'bazar',
    homeLabel: 'Inicio',
    allLabel: 'Todo el bazar',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Secciones del bazar',
    searchPlaceholder: 'Buscar deco, bazar o regalos...',
  },
  'tecno-pulse': {
    layout: 'tech-command',
    homeLabel: 'Home',
    allLabel: 'Catálogo total',
    showIndex: true,
    maxCategories: 7,
    stripAriaLabel: 'Comando de categorías',
    searchPlaceholder: 'Buscar modelo, marca o accesorio...',
  },
  'hombre-atelier': {
    layout: 'atelier',
    homeLabel: 'Portada',
    allLabel: 'Colección completa',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Colecciones destacadas',
    searchPlaceholder: 'Buscar prendas de autor...',
  },
  'mujer-maison': {
    layout: 'maison',
    homeLabel: 'Maison',
    allLabel: 'Ver colección',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Colecciones boutique',
    searchPlaceholder: 'Buscar looks, prendas o tonos...',
  },
  'deco-serena': {
    layout: 'interior',
    homeLabel: 'Estudio',
    allLabel: 'Explorar todo',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Ambientes y categorías',
    searchPlaceholder: 'Buscar por ambiente o producto...',
  },
  'kids-pop': {
    layout: 'play-pop',
    homeLabel: 'Inicio',
    allLabel: 'Todo para ver',
    showIndex: false,
    maxCategories: 8,
    stripAriaLabel: 'Categorías principales',
    searchPlaceholder: 'Buscar por edad, talle o producto...',
  },
  'beauty-glow': {
    layout: 'glow',
    homeLabel: 'Glow',
    allLabel: 'Beauty completo',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Rutinas y líneas beauty',
    searchPlaceholder: 'Buscar rutina, tono o producto...',
  },
  'sport-grid': {
    layout: 'scoreboard',
    homeLabel: 'Inicio',
    allLabel: 'Shop all',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Categorías deportivas',
    searchPlaceholder: 'Buscar equipo, talle o disciplina...',
  },
  'pet-friendly': {
    layout: 'friendly',
    homeLabel: 'Inicio',
    allLabel: 'Todo disponible',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Categorías de cuidado',
    searchPlaceholder: 'Buscar alimento, accesorio o cuidado...',
  },
  'gourmet-fresh': {
    layout: 'market-fresh',
    homeLabel: 'Mercado',
    allLabel: 'Toda la tienda',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Pasillos del mercado',
    searchPlaceholder: 'Buscar frescos, packs o sabores...',
  },
  'urban-drop': {
    layout: 'drop',
    homeLabel: 'Drop',
    allLabel: 'Todo el drop',
    showIndex: true,
    maxCategories: 7,
    stripAriaLabel: 'Drop navigation',
    searchPlaceholder: 'Buscar drop, talle o fit...',
  },
  'prisma-joyas': {
    layout: 'prisma-studio',
    homeLabel: 'Inicio',
    allLabel: 'Ver todo',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Colecciones Prisma',
    searchPlaceholder: 'Buscar anillos, dijes o colección...',
  },
  'papel-vivo': {
    layout: 'reader',
    homeLabel: 'Portada',
    allLabel: 'Biblioteca',
    showIndex: true,
    maxCategories: 7,
    stripAriaLabel: 'Secciones de lectura',
    searchPlaceholder: 'Buscar título, autor o categoría...',
  },
  'nordika-home': {
    layout: 'nordic',
    homeLabel: 'Home',
    allLabel: 'Ver ambientes',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Ambientes del hogar',
    searchPlaceholder: 'Buscar mueble, ambiente o material...',
  },
  'auto-pro': {
    layout: 'garage',
    homeLabel: 'Base',
    allLabel: 'Ver repuestos',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Categorías técnicas',
    searchPlaceholder: 'Buscar pieza, modelo o código...',
  },
  'farma-clara': {
    layout: 'health-tabs',
    homeLabel: 'Inicio',
    allLabel: 'Ver farmacia',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Categorías de salud',
    searchPlaceholder: 'Buscar producto o necesidad...',
  },
  'toolbox-pro': {
    layout: 'workbench',
    homeLabel: 'Banco',
    allLabel: 'Todo el taller',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Herramientas y categorías',
    searchPlaceholder: 'Buscar herramienta, medida o marca...',
  },
  'raiz-artesanal': {
    layout: 'craft',
    homeLabel: 'Taller',
    allLabel: 'Ver piezas',
    showIndex: false,
    maxCategories: 6,
    stripAriaLabel: 'Piezas y colecciones',
    searchPlaceholder: 'Buscar material, pieza o colección...',
  },
  'neon-gamer': {
    layout: 'neon-command',
    homeLabel: 'Start',
    allLabel: 'Full catalog',
    showIndex: true,
    maxCategories: 8,
    stripAriaLabel: 'Menú gamer',
    searchPlaceholder: 'Buscar setup, juego o componente...',
  },
  'terra-outdoor': {
    layout: 'trail',
    homeLabel: 'Inicio',
    allLabel: 'Ver todo',
    showIndex: false,
    maxCategories: 7,
    stripAriaLabel: 'Rutas y categorías outdoor',
    searchPlaceholder: 'Buscar producto, talle o categoría...',
  },
};

export const getDesignMenuProfile = (slug) => ({
  ...baseProfile,
  ...(DESIGN_MENU_PROFILES[slug] || {}),
});
